<div class="container-fluid">
    <div class="row">
        <div class="col-sm-3 col-md-2 p-0">
            <app-main-nav></app-main-nav>
        </div>
        <div class="col-sm-9 col-md-10 p-0">
            <app-top-nav></app-top-nav>
            <div class="container">
                <div class="ml-sm-auto pt-3 px-4">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>